import { migrationRows, oldEntries } from "@/mocks/homeContent";

const oldStatus: Record<string, { cls: string; icon: string }> = {
  offline: { cls: "bg-background-200 text-foreground-600", icon: "ri-forbid-2-line" },
  redirect: { cls: "bg-secondary-100 text-secondary-800", icon: "ri-arrow-right-circle-line" },
  archived: { cls: "bg-accent-100 text-accent-800", icon: "ri-archive-drawer-line" },
};

function MigrationArchive() {
  return (
    <section id="migrate" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5 lg:gap-8">
          {/* migration records */}
          <div className="lg:col-span-3">
            <div className="flex flex-col items-start">
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
                <i className="ri-route-fill"></i>
                域名迁移记录
              </span>
              <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                每一次换新地址都有据可查
              </h2>
              <p className="mt-3 text-sm leading-6 text-foreground-600">
                从旧网址迁往换新地址，原因与影响时间逐条登记，构成完整的域名迁移链条。
              </p>
            </div>

            <div className="mt-7 overflow-hidden rounded-2xl border border-background-200 bg-background-50">
              {/* header */}
              <div className="hidden grid-cols-[56px_1.4fr_1fr_120px_120px_150px] items-center gap-2 bg-background-100 px-5 py-3 text-xs font-semibold text-foreground-500 md:grid">
                <span>轮次</span>
                <span>旧网址 → 换新地址</span>
                <span>迁移日期</span>
                <span>原因</span>
                <span>影响时长</span>
                <span className="text-right">状态</span>
              </div>
              <ul>
                {migrationRows.map((row, i) => (
                  <li
                    key={row.no}
                    className={`grid grid-cols-1 gap-3 px-5 py-4 text-sm md:grid-cols-[56px_1.4fr_1fr_120px_120px_150px] md:items-center md:gap-2 ${
                      i !== migrationRows.length - 1
                        ? "border-b border-background-100"
                        : ""
                    }`}
                  >
                    <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-50 font-heading text-xs font-bold text-primary-600 md:h-auto md:w-auto md:rounded-none md:bg-transparent">
                      #{row.no}
                    </span>
                    <div className="flex flex-wrap items-center gap-1.5">
                      <span className="rounded-md bg-background-200 px-2 py-1 font-heading text-xs font-semibold text-foreground-500 line-through decoration-foreground-400/60">
                        {row.from}
                      </span>
                      <i className="ri-arrow-right-line text-secondary-600"></i>
                      <span className="rounded-md bg-accent-100 px-2 py-1 font-heading text-xs font-bold text-accent-800">
                        {row.to}
                      </span>
                    </div>
                    <span className="text-xs text-foreground-500 md:text-sm">{row.date}</span>
                    <span className="text-xs text-foreground-600">{row.reason}</span>
                    <span className="text-xs text-foreground-600">{row.impact}</span>
                    <span className="flex items-center justify-start gap-1.5 whitespace-nowrap text-xs font-semibold text-foreground-700 md:justify-end">
                      <i className="ri-checkbox-circle-fill text-accent-600"></i>
                      已迁移
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* old url archive */}
          <div className="lg:col-span-2">
            <div className="flex flex-col items-start rounded-2xl bg-foreground-950 p-6 text-background-50 md:p-7">
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/10 px-3 py-1 text-xs font-semibold ring-1 ring-background-50/20">
                <i className="ri-archive-fill text-secondary-300"></i>
                旧网址汇总
              </span>
              <h2 className="mt-4 font-heading text-xl font-bold tracking-tight md:text-2xl">
                往期旧网址去向一览
              </h2>
              <p className="mt-3 text-sm leading-6 text-foreground-200">
                每个旧网址都标记了当前状态：已停用、已跳转还是可归档回溯。看到旧网址先核对这里，
                避免误入仿冒入口。
              </p>

              <ul className="mt-6 w-full space-y-3">
                {oldEntries.map((entry) => {
                  const st = oldStatus[entry.status];
                  return (
                    <li
                      key={entry.domain}
                      className="rounded-xl bg-background-50/5 p-3.5 ring-1 ring-background-50/10"
                    >
                      <div className="flex items-center justify-between">
                        <span className="font-heading text-sm font-bold text-background-50">
                          {entry.domain}
                        </span>
                        <span
                          className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-[11px] font-semibold ${st.cls}`}
                        >
                          <i className={`${st.icon} text-[11px]`}></i>
                          {entry.statusText}
                        </span>
                      </div>
                      <p className="mt-1 text-[11px] text-foreground-300">使用期：{entry.range}</p>
                      <p className="mt-1.5 text-xs leading-5 text-foreground-200">{entry.note}</p>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MigrationArchive;